import axios from "axios"
export const uploadFile = (fileData, token) => {
    return axios.post(process.env.REACT_APP_API_URL+ '/uploadFile', fileData, {
        headers: {
            'Authorization': `${token}`
        }});
}